// Step 3
// Enter user Details
import { parsePhoneNumber } from "awesome-phonenumber";
import React from "react";
import Global from "../../common/global";
import Helper from "../../common/helper";
import ErrorComponent from "../../components/UI/error";

import NextButton from "../../components/UI/next-button";

// import InputFields from "../../common/input";
import CardAsset from "../UI/card-asset";
import { CheckBoxTick, CheckBoxBlank } from "../../common/icons";

import clsx from "clsx";
import StepsIndicator from "../steps-indicator";
import BackButton from "../UI/back-button";
import Layout from "../layout";
import ErrorValidation from "../UI/error-input-validation";

export const SubHeader = ({ headerMsg, className }) => (
  <h3
    className={`font-montserrat font-semibold text-sm uppercase text-[#557B97] ${className}`}
  >
    {headerMsg}
  </h3>
);

export const TextBold = ({ textContent, className }) => (
  <span
    className={`font-montserrat font-bold text-sm text-[#050033] ${className}`}
  >
    {textContent}
  </span>
);

export const getPreferredLanguage = (language) => {
  const { PREFERRED_LANGUAGE } = Global;
  const preferredLanguageList = PREFERRED_LANGUAGE.filter(
    (prefLang) => prefLang.value === language
  );
  const preferredLanguage = preferredLanguageList[0]?.text;

  return preferredLanguage;
};

export default function ReviewStep({
  languages,
  localStorageDatas,
  editItemLink,
  readMeTerms,
  locationData,
  handleShowList,
  inputPromoEl,
  isRenewalPage,
  handleCardCheckBox,
  removeProduct,
  handleCheckBoxTerms,
  checkBoxTerms,
  currentStep,
  stepNo,
  editReview,
  isExpress,
  memberCreationError,
  couponObj,
  isUserLogged,
  businessCategories,
  reviewLoading,
  checkBoxTermsQBR,
  confirmOrder,
  isProcessing,
  goNextStep,
  isDisabled,
  goPreviousStep,
  handleNextStep,
  checkboxError,
}) {
  if (currentStep !== stepNo) {
    return null;
  }


  const urlRedirector = (pathRedirect) => {
    const pathName = window.location.pathname;
    let urlPlaceholder;
    if (isRenewalPage) {
      urlPlaceholder = `https://${
        window.location.host
      }${pathName.replace("/renewals/", "/")}${pathRedirect}`;
    } else if (isExpress) {
      urlPlaceholder = `https://${
        window.location.host
      }${pathName.replace("/express-checkout/", "/")}${pathRedirect}`;
    } else {
      urlPlaceholder = `https://${
        window.location.host
      }${pathName.replace("/registration/", "/")}${pathRedirect}`;
    }
    console.warn("urlPlaceholder", urlPlaceholder);

    return urlPlaceholder;
  }
  const termsAndConditionsLinkURL = urlRedirector("about/terms-and-conditions");
  const dataPrivacyLinkURL = urlRedirector("data-privacy-charter");
  
  const PERSONAL_DETAILS =
    "https://secure.accor.com/account/index.en.shtml#/information/personal";
  const SSO_LOGIN = Global.LOGIN_URL;
  const isAMEX = Helper.isAMEX()
  let currencyText = "";

  if (
    Object.keys(localStorageDatas.members[0]?.selected_product).length !== 0
  ) {
    if (
      localStorageDatas &&
      localStorageDatas.members.length > 0 &&
      localStorageDatas.members[0].selected_product &&
      localStorageDatas.members[0].selected_product[0].currency_text
    ) {
      currencyText =
        localStorageDatas.members[0].selected_product[0].currency_text;
    }
  }

  var totalnum = 0;
  var totalGst = 0;

  if (Object.keys(localStorageDatas.members[0].selected_product).length !== 0) {
    for (var i = 0; i < localStorageDatas.members.length; i++) {
      let price = "";
      let gst = "";
      if (
        localStorageDatas.members[0].selected_product &&
        localStorageDatas.members[0].selected_product[0].purchase_price
      ) {
        price = parseFloat(
          localStorageDatas.members[i].selected_product[0].purchase_price
        );
        gst = parseFloat(
          localStorageDatas.members[i].selected_product[0].tax_amt
        );
      }
      totalnum += price;
      totalGst += gst;
    }
    var totalAmt = totalnum + totalGst;
  }

  var couponExists = false;
  var totalAmount = "";

  return (
    <Layout>
      <div className="grid grid-cols-1 tablet:grid-cols-2 tablet:gap-4">
        <div className="flex flex-col mx-auto xs:mx-0">
          <BackButton goPreviousStep={goPreviousStep} />
          <CardAsset />
        </div>

        <div className="w-[420px] xs:w-auto">
          <StepsIndicator
            step={currentStep}
            stepText={languages.stepTitle3 ? languages.stepTitle3 : "Order review"}
            subTitleHeader={languages.reviewYourOrder ? languages.reviewYourOrder : "Review your order"}
            languages={languages}
          />

          <div className="wrapper-review">
            <div id="review-left-pane">
              {localStorageDatas.members.map((item, index) => {
                let selected_item = item.selected_product[0];
                const getCoupon = Helper.checkCoupon(selected_item, couponObj);
                const PWP = Helper.newpwpCheck(
                  selected_item,
                  isUserLogged,
                  locationData,
                  businessCategories
                );
                const {
                  isShown,
                  title,
                  type_of_member,
                  selected_product,
                  leah_card_number,
                  first_name,
                  last_name,
                  phone_number,
                  address_line_1,
                  address_line_2,
                  address_line_3,
                  city,
                  state,
                  postal_code,
                  country,
                  email,
                  preferred_language,
                } = item;

                const formatPhoneNumber = parsePhoneNumber(
                  `+${phone_number?.inputVal}`
                );

                if (getCoupon.exists == true) {
                  couponExists = true;
                  totalAmount = getCoupon.total + " (coupon applied)";
                } else if (
                  selected_product &&
                  selected_item &&
                  selected_item.tax_amt
                ) {
                  totalAmount =
                    parseFloat(selected_item.purchase_price) +
                    parseFloat(selected_item.tax_amt);
                }
                return (
                  <div
                    className="holder-review-details flex flex-col border border-gray-400 rounded p-4"
                    key={index}
                  >
                    {/* <div className='holder-review-button ml-auto mb-1'>
                          {
                            type_of_member === 'primary_owner' ? null : (
                           !isExpress ? (
                                <button
                                  type='button'
                                  onClick={() => removeProduct(item)}
                                >x {languages.removeText ? languages.removeText : 'Remove'}
                                </button>
                              ) : ''
                            )
                          }
                        </div> */}

                    <div className="holder-title flex flex-col justify-center gap-4">
                      <div id="contact-information">
                        <SubHeader
                          headerMsg={languages.contactInfoSummary ? languages.contactInfoSummary : "Contact information summary"}
                          className="mb-5"
                        />
                        {isExpress && type_of_member === "primary_owner" ? (
                          <ul className="details-list">
                            <li className="list pt-1 font-montserrat">
                              <strong>
                                {languages.membershipNumber
                                  ? languages.membershipNumber
                                  : "Membership number"}
                              </strong>{" "}
                              {leah_card_number}
                            </li>
                          </ul>
                        ) : isExpress && isShown ? (
                          <ul className="details-list">
                            <li className="list pt-1 font-montserrat">
                              <strong>
                                {languages.membershipNumber
                                  ? languages.membershipNumber
                                  : "Membership number"}
                              </strong>{" "}
                              {leah_card_number}
                            </li>
                          </ul>
                        ) : isRenewalPage && isShown ? (
                          <ul className="details-list">
                            <li className="list pt-1 font-montserrat capitalize">
                              {`${title} ${first_name} ${last_name}`}
                            </li>
                            <li
                              className="list pt-1 font-montserrat truncate"
                              title={email}
                            >
                              {email}
                            </li>
                            <li className="list pt-1 font-montserrat">
                              {phone_number.leahNum === undefined
                                ? phone_number
                                : phone_number.leahNum}
                            </li>
                            <li className="list pt-1 font-montserrat">
                              {address_line_1} {address_line_2},{" "}
                              {address_line_3}
                            </li>
                            <li className="list pt-1 font-montserrat">
                              {city} {state},{" "}
                              <span className="uppercase">{postal_code}</span>
                            </li>
                            <li className="list pt-1 font-montserrat">
                              {" "}
                              <span>{country}</span>
                            </li>
                          </ul>
                        ) : (
                          !isExpress &&
                          !isRenewalPage &&
                          isShown && (
                            <ul className="details-list">
                              <li className="list pt-1 font-montserrat capitalize">{`${title} ${first_name} ${last_name}`}</li>
                              <li
                                className="list pt-1 font-montserrat truncate"
                                title={email}
                              >
                                <TextBold
                                  textContent={`${languages.email ? languages.email : "Email"}:`}
                                  className="text-base"
                                />{" "}
                                {email}
                              </li>
                              <li className="list pt-1 font-montserrat">
                                <TextBold
                                  textContent={`${languages.phoneNumber ? languages.phoneNumber : "Phone number"}:`}
                                  className="text-base"
                                />{" "}
                                {formatPhoneNumber?.number?.international}
                              </li>
                              <li className="list pt-1 font-montserrat">
                                <TextBold
                                  textContent={`${languages.postCode ? languages.postCode : "Postal code"}:`}
                                  className="text-base"
                                />{" "}
                                {postal_code}
                              </li>
                              <li className="list pt-1 font-montserrat">
                                <TextBold
                                  textContent={`${languages.country ? languages.country : "Country"}:`}
                                  className="text-base"
                                />{" "}
                                {country}
                              </li>
                              <li className="list pt-1 font-montserrat">
                                <TextBold
                                  textContent={`${languages.preferredLanguage ? languages.preferredLanguage : "Preferred language"}:`}
                                  className="text-base"
                                />{" "}
                                {getPreferredLanguage(preferred_language) ||
                                  "English"}
                              </li>
                            </ul>
                          )
                        )}
                      </div>

                      <hr className="border-[#D9D9D9]" />

                      <div id="membership-information" className="mt-1">
                        <SubHeader
                          headerMsg={isAMEX ? "Your card" : (languages.cardSubscriptionPeriod ? languages.cardSubscriptionPeriod : "Your card and subscription period")}
                          className="mb-5"
                        />

                        <TextBold
                          textContent={
                            item.selected_product[0].item_group_description
                          }
                          className="text-base"
                        />
                        {!isAMEX && (
                          <div className="font-montserrat font-normal pt-1">
                            {languages.oneYearSubscription
                              ? languages.oneYearSubscription
                              : "1 year subscription"}
                          </div>
                        )}
                        {PWP.isPWPExclusive ? (
                          <React.Fragment>
                            <div>
                              <span className="font-montserrat font-medium">
                                {PWP.points}{" "}
                              </span>
                              <span className="font-montserrat uppercase">
                                {" "}
                                {languages.reviewPwpText
                                  ? languages.reviewPwpText
                                  : "ALL Reward points"}
                              </span>
                            </div>
                          </React.Fragment>
                        ) : (
                          <div className="mt-1">
                            <span className="font-montserrat uppercase">
                              {item.selected_product[0].currency_text}{" "}
                            </span>
                            <span className="font-montserrat font-medium">
                              {totalAmount}
                            </span>{" "}
                            {PWP.exists &&
                              !item.selected_product[0].isQbr &&
                              isUserLogged && (
                                <React.Fragment>
                                  {" "}
                                  <span className="font-montserrat">
                                    {languages.multiProductOr
                                      ? languages.multiProductOr
                                      : "OR"}
                                  </span>{" "}
                                  <span className="font-montserrat font-medium">
                                    {PWP.points}
                                  </span>{" "}
                                  <span className="font-montserrat uppercase">
                                    {languages.reviewPwpText
                                      ? languages.reviewPwpText
                                      : "ALL Reward points"}{" "}
                                    {languages.reviewPerYear
                                      ? languages.reviewPerYear
                                      : "Per Year "}
                                  </span>
                                  <br />
                                </React.Fragment>
                              )}
                            {item.selected_product[0].isQbr && (
                              <div className="mb-3">
                                {/* <p className='font-montserrat'>Earn {item.selected_product[0].qbrPoints} Qantas Points with Qantas Business Rewards*</p> */}
                                {languages.qbrRewardPoints ? (
                                  <p className="font-montserrat">
                                    Earn {item.selected_product[0].qbrPoints}{" "}
                                    Qantas Points with Qantas Business Rewards
                                    and {languages.qbrRewardPoints} ALL reward
                                    points
                                  </p>
                                ) : (
                                  <p className="font-montserrat">
                                    Earn {item.selected_product[0].qbrPoints}{" "}
                                    Qantas Points with Qantas Business Rewards*
                                  </p>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className={clsx("details ", {
                        rotated: isShown,
                      })}
                    ></div>
                  </div>
                );
              })}
            </div>
            <div id="review-right-pane">
              <div className="flex items-stretch mt-5">
                <input
                  id="link-checkbox-terms"
                  type="checkbox"
                  checked={checkBoxTerms}
                  onChange={handleCheckBoxTerms}
                  // className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label
                  htmlFor="link-checkbox-terms"
                  className="flex justify-center items-start text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  <span
                    className={`mr-2 ${
                      checkboxError && !checkBoxTerms
                        ? `checkbox-icon-error ${checkBoxTerms} focus:ring-[#BA1F1A] focus:border-[#BA1F1A]`
                        : `checkbox-icon ${checkBoxTerms}`
                    }`}
                  >
                    {checkBoxTerms ? <CheckBoxTick /> : <CheckBoxBlank />}
                  </span>
                  <span
                    ref={readMeTerms}
                    className="text-[#6F6E77] font-normal leading-5 font-inter text-sm text-justify tracking-tight"
                  >
                    {/* {languages.termsAndConditions ? languages.termsAndConditions : 'I confirm that I have read and accepted the '}  */}
                    {/* <a                   
                      className='text-green text-underline'
                      href={termsAndConditionsLinkURL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span> {languages.termsLinkTitle ? languages.termsLinkTitle : 'terms and conditions of sale.'}</span>
                    </a>. */}
                    {languages.newTerms
                      ? languages.newTerms
                      : "I agree that Accor Plus will send me tailored information about Accor Plus offers, events, and other activities."}
                  </span>
                </label>
              </div>
              <div className="flex flex-col mt-5 items-stretch">
                {/* <input 
                  id="link-checkbox-terms" 
                  type="checkbox" 
                  checked={checkBoxTerms}
                  onChange={handleCheckBoxTerms}
                  // className="d-none w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                /> */}
                <span
                  className={`flex justify-center items-start text-sm font-medium text-gray-900 dark:text-gray-300 ${
                    checkboxError && !checkBoxTerms ? "tc-error" : ""
                  }`}
                >
                  {/* <span className={`mr-2 ${`checkbox-icon ${checkBoxTerms}`}`}>{ checkBoxTerms ? <CheckBoxTick /> : <CheckBoxBlank/>}</span> */}

                  <span
                    ref={readMeTerms}
                    className="text-[#6F6E77] font-normal leading-5 font-inter text-sm text-justify tracking-tight"
                  >
                    {languages.termsAndConditions
                      ? languages.termsAndConditions
                      : "By clicking on “Confirm”, I agree and accept Accor Plus Terms and conditions and the Accor Plus"}
                    <span className="holder-links">
                      <a
                        className="text-green text-underline"
                        href={termsAndConditionsLinkURL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="ml-1">
                          {languages.termsAndConditionText
                            ? languages.termsAndConditionText
                            : "Terms and conditions"}
                        </span>
                      </a>
                    </span>
                    <span>
                      {" "}
                      {languages.andAccorPlus
                        ? languages.andAccorPlus
                        : "and the Accor Plus"}
                    </span>
                    <span className="holder-links">
                      <a
                        className="text-green text-underline"
                        href={dataPrivacyLinkURL}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="ml-1">
                          {languages.termsLinkTitle
                            ? languages.termsLinkTitle
                            : "Data Privacy Charter"}
                        </span>
                      </a>
                      .
                    </span>
                  </span>
                </span>
                <span className="flex mt-2 tc-error-message">
                  {checkboxError && !checkBoxTerms && (
                    <ErrorValidation
                      errorMessage={
                        "Please read and accept the Terms & Conditions to proceed."
                      }
                    />
                  )}
                </span>
              </div>

              {memberCreationError ? (
                <div class="mt-5">
                  <ErrorComponent
                    errorMessage={memberCreationError}
                    languages={languages}
                  />
                </div>
              ) : (
                ""
              )}

              <NextButton
                isProcessing={isProcessing}
                goNextStep={goNextStep}
                languages={languages}
                isDisabled={isDisabled}
                stepNo={stepNo}
                currentStep={currentStep}
                checkBoxTerms={checkBoxTerms}
                confirmOrder={confirmOrder}
                handleNextStep={handleNextStep}
                reviewLoading={reviewLoading}
                checkboxError={checkboxError}
              />
              {localStorageDatas.members.map((item, index) => {
                console.log(
                  "isExplorer",
                  item.selected_product[0]?.item_group_name.includes("EXPLORER")
                );
                let EXPLORER =
                  item.selected_product[0]?.item_group_name.includes(
                    "EXPLORER"
                  );
                if (EXPLORER && !isAMEX) {
                  return (
                    <p className="text-[#6F6E77] font-normal leading-5 font-inter text-sm my-5 text-justify">
                      {languages.subscriptionRenewalContent
                        ? languages.subscriptionRenewalContent
                        : "Your membership will renew automatically each year, ensuring uninterrupted access to your benefits. If you'd like to cancel, you can do so at any time up to one month before your renewal date by following the steps outlined in our Terms and Conditions."}
                    </p>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
